import React, {createContext, useEffect, useMemo, useReducer, useState} from 'react';
import Layout from '../../Shared/Layout';
import {Container, InputLabel, MenuItem, Select} from "@material-ui/core";
import styled from "styled-components";
import FormPage from "../../Shared/FormPage";
import {map} from "lodash";
import BackButton from "../../Shared/BackButton";
import {DynamicColorPreset} from "../../Shared/DynamicColorPreset";
import i18n, {Trans} from "../../utils/i18n";
import MuiButton from "@material-ui/core/Button";
import {Inertia} from "@inertiajs/inertia";
import {useForm, usePage} from "@inertiajs/inertia-react";
import {FormState} from "../../FormComponents/FormState";
import classNames from "classnames";
import TextField from '@mui/material/TextField';
import Autocomplete, {createFilterOptions} from '@mui/material/Autocomplete';
import SearchIcon from "@material-ui/icons/Search";
import FormControl from "@material-ui/core/FormControl";
import {DatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import {isToday} from "date-fns";
import {Button, Checkbox, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import dayjs from "dayjs";
import Dialog from "@mui/material/Dialog";
import {AddCircleOutline} from "@material-ui/icons";
import {useQuery} from "@tanstack/react-query";
import {getCookieValue} from "../../utils/getCookieValue";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import MuiCheckbox from "@material-ui/core/Checkbox";
import {matchSorter} from "match-sorter";
import {useTranslation} from "react-i18next";


const fetchProducts = () => {
    return fetch(route('emissions.products'), {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-XSRF-TOKEN': getCookieValue('XSRF-TOKEN'),
            'X-Requested-With': 'XMLHttpRequest',
        },
    })
        .then(response => response.json());
};

const filterOptions = createFilterOptions({
    matchFrom: 'start',
    stringify: (option) => option.description,
    ignoreAccents: true,
    ignoreCase: true,
});
const filterOptions2 = (options, {inputValue}) => {
    return matchSorter(options, inputValue, {
        keys: ['description'],
    });
};

const categories = [
    {name: 'Mobiles', icon: 'phone_iphone'},
    {name: 'Tablets', icon: 'tablet_mac'},
    {name: 'Wearables', icon: 'watch'},
    {name: 'Laptops', icon: 'laptop_mac'},
    {name: 'IOT', icon: 'router'},
    {name: 'e-Mobility', icon: 'electric_scooter'},
    {name: 'e-Book', icon: 'book'},
    {name: 'Routers', icon: 'settings_input_antenna'},
    {name: 'TV', icon: 'tv'},
    {name: 'Other', icon: 'devices_other'},
];

const CategoryCard = ({name, icon}) => {
    return (
        <div className="flex flex-col items-center justify-center bg-white rounded-lg shadow-md p-6 m-2">
            <span className="material-icons mb-2">{icon}</span>
            <span className="text-sm">{name}</span>
        </div>
    );
};

export default function Emissions({countries, isEnterprise, user,}) {
    const {t} = useTranslation();
    const [open, setOpen] = useState(false);
    const productQuery = useQuery({
        queryKey: ['emissions.products'],
        queryFn: fetchProducts
    });
    const products = productQuery?.data?.products || [];
    const [brand, setBrand] = useState(null);
    const brands = useMemo(() => {
        return products
            .reduce((acc, item) => {
                if (!acc.includes(item.brand)) {
                    acc.push(item.brand);
                }
                return acc;
            }, [])
            .filter(Boolean);
    }, [products]);

    const {
        data,
        setData,
        post,
        processing,
    } = useForm({
        email: '',
        devices: [],
        isEnterprise,
    });
    const errors = data.devices.map(item => ({
        activationTime: !item.activationTime,
        issues: item.issues.map(item => ({
            issue_id: !item.issue_id,
            amount: !item.amount,
            country: !item.country,
        })),
    }));
    const errorFree = errors.every(item => item.issues.length > 0 && item.issues.every(issue => !issue.country && !issue.issue_id && !issue.amount));

    const handleClickOpen = () => {
        if (isEnterprise) {
            post(route('emissions.store'))
            return;
        }
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const staticProducts = useMemo(() => {
        return products
            ?.filter(item => !map(data.devices, 'entry.id').includes(item.id))
            ?.filter(item => brand ? item.brand === brand : true)
            .map(item => ({
                ...item,
                key: item.id,
            }));
    }, [products, data.devices, brand]);

    return (
        <div className={'bg-[#F6F6F6] flex-1 flex flex-col pt-12 -mt-12 min-h-screen'}>
            <div className={'flex-1  z-10'}>
                <Container maxWidth="md">
                    <h1>
                        {
                            isEnterprise ?
                                <Trans i18nKey="emissions.heading1.enterprise">
                                    Search and add one or more devices
                                </Trans>
                                :
                                <Trans i18nKey="emissions.heading1">
                                    Search and select a device
                                </Trans>
                        }
                    </h1>
                    <div className={'mb-6 brand-box-wrapper'}>
                        <Autocomplete
                            disablePortal
                            sx={{backgroundColor: '#eeeeee'}}
                            id="brand-box"
                            options={brands}
                            renderInput={(params) => <TextField
                                {...params}
                                // label="Devices"
                                InputProps={{
                                    ...params.InputProps,
                                    sx: {
                                        borderRadius: '0 !important',
                                        backgroundColor: '#fff',
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            border: 'none',
                                            borderBottom: '3px solid #3D5166',
                                            borderRadius: 0,
                                        }
                                    },
                                    startAdornment: <SearchIcon/>,
                                }}
                                placeholder={'Brand'}
                            />}
                            disabled={data.devices.length > 0 && !isEnterprise}
                            // getOptionLabel={(option) => option}
                            onChange={(event, value) => {
                                setBrand(value);
                            }}
                        />
                    </div>
                    <div className={'products-wrapper'}>
                        {
                            staticProducts.length > 0 &&
                            <Autocomplete
                                disablePortal
                                sx={{backgroundColor: '#eeeeee'}}
                                id="combo-box-demo"
                                options={staticProducts}
                                renderInput={(params) => <TextField
                                    {...params}
                                    InputProps={{
                                        ...params.InputProps,
                                        sx: {
                                            borderRadius: '0 !important',
                                            backgroundColor: '#fff',
                                            '& .MuiOutlinedInput-notchedOutline': {
                                                border: 'none',
                                                borderBottom: '3px solid #3D5166',
                                                borderRadius: 0,
                                            }
                                        },
                                        startAdornment: <SearchIcon/>,
                                    }}
                                    placeholder={t("device.model")}
                                />}
                                disabled={data.devices.length > 0 && !isEnterprise}
                                getOptionLabel={(option) => option.description} filterOptions={filterOptions2}
                                onChange={(event, value) => {
                                    if (!value) return;
                                    setData('devices', [
                                        ...data.devices,
                                        {
                                            entry: value,
                                            activationTime: '',
                                            issues: [{
                                                issue_id: '',
                                                amount: 1,
                                                country: '',
                                            }],
                                        },
                                    ]);
                                }}
                                renderOption={(props, option) => {
                                    return <div {...props} key={option.id}>
                                        {
                                            option.description
                                        }
                                    </div>
                                }}
                            />
                        }
                    </div>

                    {/*<div className="p-10">*/}
                    {/*    <div className="max-w-screen-lg mx-auto">*/}
                    {/*        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">*/}
                    {/*            {categories.map((category) => (*/}
                    {/*                <CategoryCard key={category.name} name={category.name} icon={category.icon}/>*/}
                    {/*            ))}*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    <div className={'grid grid-cols-12 gap-3 my-16 '}>
                        {
                            data.devices.length === 1 && (
                                <div className={'col-span-3'}>
                                </div>
                            )
                        }
                        {
                            data.devices.map((device, index) => (
                                <div
                                    className={'col-span-12 md:col-span-6 shadow-lg flex flex-col p-9 items-center bg-white rounded-lg'}
                                    key={device.entry.id}>
                                    <h2 className={'text-center min-h-14 m-0'}>{device.entry.description}</h2>
                                    <div className={'min-h-[8.5rem]'}>
                                        {
                                            device.entry.image &&
                                            <img src={device.entry.image} alt={'Device image'}
                                                 className={'h-32'}/>
                                        }
                                        {
                                            !device.entry.image && device.entry.description.toLowerCase().includes('iphone') &&
                                            <img src={`/images/b2x_carbon/placeholder_apple.svg`} alt={'Apple device'}
                                                 className={'h-32'}/>
                                        }
                                        {
                                            !device.entry.image && !device.entry.description.toLowerCase().includes('iphone') &&
                                            <img src={`/images/b2x_carbon/placeholder_android.svg`}
                                                 alt={'Android device'} className={'h-32'}/>
                                        }
                                    </div>
                                    <p
                                        onClick={() => {
                                            setData('devices', data.devices.filter((item, i) => i !== index));
                                        }}
                                        className={'text-red-500 cursor-pointer font-bold mb-6 mt-3'}
                                    >
                                        <Trans i18nKey="emissions.deleteDevice">
                                            Delete device
                                        </Trans>
                                        <svg width="17" height="16" viewBox="0 0 17 16" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <rect width="16" height="16" transform="translate(0.5)" fill="white"/>
                                            <path fillRule="evenodd" clipRule="evenodd"
                                                  d="M6.76704 2.60021C6.90248 2.46476 7.08618 2.38867 7.27772 2.38867H9.72217C9.91371 2.38867 10.0974 2.46476 10.2329 2.60021C10.3683 2.73565 10.4444 2.91935 10.4444 3.11089V3.83313H6.5555V3.11089C6.5555 2.91935 6.63159 2.73565 6.76704 2.60021ZM5.5555 3.83313V3.11089C5.5555 2.65413 5.73695 2.21608 6.05993 1.8931C6.38291 1.57012 6.82096 1.38867 7.27772 1.38867H9.72217C10.1789 1.38867 10.617 1.57012 10.94 1.8931C11.2629 2.21608 11.4444 2.65413 11.4444 3.11089V3.83313H12.774L12.7777 3.83312L12.7814 3.83313H14C14.2761 3.83313 14.5 4.05699 14.5 4.33313C14.5 4.60927 14.2761 4.83313 14 4.83313H13.2777V12.8887C13.2777 13.3454 13.0963 13.7835 12.7733 14.1065C12.4503 14.4294 12.0123 14.6109 11.5555 14.6109H5.44439C4.98763 14.6109 4.54957 14.4294 4.2266 14.1065C3.90362 13.7835 3.72217 13.3454 3.72217 12.8887V4.83313H3C2.72386 4.83313 2.5 4.60927 2.5 4.33313C2.5 4.05699 2.72386 3.83313 3 3.83313H4.21844L4.22217 3.83312L4.22589 3.83313H5.5555ZM4.72217 4.83313V12.8887C4.72217 13.0802 4.79826 13.2639 4.9337 13.3994C5.06914 13.5348 5.25285 13.6109 5.44439 13.6109H11.5555C11.747 13.6109 11.9307 13.5348 12.0662 13.3994C12.2016 13.2639 12.2777 13.0802 12.2777 12.8887V4.83313H4.72217ZM7.27783 6.88867C7.55397 6.88867 7.77783 7.11253 7.77783 7.38867V11.0553C7.77783 11.3315 7.55397 11.5553 7.27783 11.5553C7.00169 11.5553 6.77783 11.3315 6.77783 11.0553V7.38867C6.77783 7.11253 7.00169 6.88867 7.27783 6.88867ZM10.2222 7.38867C10.2222 7.11253 9.99831 6.88867 9.72217 6.88867C9.44603 6.88867 9.22217 7.11253 9.22217 7.38867V11.0553C9.22217 11.3315 9.44603 11.5553 9.72217 11.5553C9.99831 11.5553 10.2222 11.3315 10.2222 11.0553V7.38867Z"
                                                  fill="#DD3535"/>
                                        </svg>
                                    </p>
                                    {/*<p>*/}
                                    {/*    Device region and activation time*/}
                                    {/*    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">*/}
                                    {/*        <rect width="16" height="16" transform="matrix(1 0 0 -1 0 16.5)" fill="white"/>*/}
                                    {/*        <path fillRule="evenodd" clipRule="evenodd" d="M8.02782 13.7998C5.08545 13.7998 2.7002 11.4145 2.7002 8.47218C2.7002 5.52981 5.08545 3.14455 8.02782 3.14455C10.9702 3.14455 13.3554 5.52981 13.3554 8.47218C13.3554 11.4145 10.9702 13.7998 8.02782 13.7998ZM1.7002 8.47218C1.7002 11.9668 4.53317 14.7998 8.02782 14.7998C11.5225 14.7998 14.3554 11.9668 14.3554 8.47218C14.3554 4.97753 11.5225 2.14455 8.02782 2.14455C4.53317 2.14455 1.7002 4.97753 1.7002 8.47218ZM8.02783 7.97217C8.30397 7.97217 8.52783 8.19603 8.52783 8.47217V10.8032C8.52783 11.0794 8.30397 11.3032 8.02783 11.3032C7.75169 11.3032 7.52783 11.0794 7.52783 10.8032V8.47217C7.52783 8.19603 7.75169 7.97217 8.02783 7.97217ZM8.02783 5.64111C7.75169 5.64111 7.52783 5.86497 7.52783 6.14111C7.52783 6.41726 7.75169 6.64111 8.02783 6.64111H8.03412C8.31026 6.64111 8.53411 6.41726 8.53411 6.14111C8.53411 5.86497 8.31026 5.64111 8.03412 5.64111H8.02783Z" fill="black"/>*/}
                                    {/*    </svg>*/}
                                    {/*</p>*/}
                                    <div className={'grid grid-cols-12 gap-3 w-full text-left'}>
                                        {/* {
                                            !isEnterprise && (
                                                <div className={'col-span-6'}>
                                                    <FormControl variant="outlined" className={'col-span-6'}>
                                                        <InputLabel id="filter-client" shrink    >
                                                            <Trans i18nKey="emissions.activationTime">How old is your device?</Trans>
                                                        </InputLabel>
                                                        <Select
                                                            labelId="filter-client"
                                                            label={
                                                                <Trans i18nKey="emissions.activationTime">How old is your device?</Trans>
                                                            }
                                                            value={device.activationTime}
                                                            onChange={(e) =>
                                                                    setData('devices', data.devices.map((item, i) => {
                                                                            if (i === index) {
                                                                                item.activationTime = e.target.value;
                                                                            }
                                                                            return item;
                                                                        }
                                                                    ),
                                                                )
                                                            }
                                                            notched
                                                            name={'activationTime'}
                                                        >
                                                            {[
                                                                {
                                                                    id: 3,
                                                                    name: '0 to 6 months',
                                                                },
                                                                {
                                                                    id: 9,
                                                                    name: '6 to 12 months',
                                                                },
                                                                {
                                                                    id: 12,
                                                                    name: '1 year',
                                                                },
                                                                {
                                                                    id: 24,
                                                                    name: '2 years',
                                                                },
                                                                {
                                                                    id: 36,
                                                                    name: '+3 years',
                                                                },
                                                            ]
                                                                .map((country) => {
                                                                    return (
                                                                        <MenuItem
                                                                            key={country.id}
                                                                            value={country.id}
                                                                        >
                                                                            {country.name}
                                                                        </MenuItem>
                                                                    );
                                                                })}
                                                        </Select>
                                                    </FormControl>
                                                </div>
                                            )
                                        } */}
                                    </div>
                                    {
                                        device.issues.map((issue, issueIndex) => (
                                            <div className={'w-full text-left mt-3 grid grid-cols-12 gap-3'}
                                                 key={issueIndex}>
                                                <div className={'col-span-12'}>
                                                    <FormControl variant="outlined" className={classNames({
                                                        'col-span-12': true,
                                                    })}>
                                                        <InputLabel id="filter-client" shrink>
                                                            <Trans i18nKey="common.country">Country</Trans>
                                                        </InputLabel>
                                                        <Select
                                                            labelId="filter-country"
                                                            label={
                                                                <Trans i18nKey="common.country">
                                                                    Country
                                                                </Trans>
                                                            }
                                                            onChange={(e) =>
                                                                setData('devices', data.devices.map((item, i) => {
                                                                            if (i === index) {
                                                                                item.issues = item.issues.map((issueItem, i) => {
                                                                                        if (i === issueIndex) {
                                                                                            issueItem.country = e.target.value;
                                                                                        }
                                                                                        return issueItem;
                                                                                    }
                                                                                )
                                                                            }
                                                                            return item;
                                                                        }
                                                                    ),
                                                                )}
                                                            value={issue.country}
                                                            notched
                                                            name={'country'}
                                                        >
                                                            {countries
                                                                .map((country) => {
                                                                    return (
                                                                        <MenuItem
                                                                            key={country.id}
                                                                            value={country.id}
                                                                        >
                                                                            {country.name}
                                                                        </MenuItem>
                                                                    );
                                                                })}
                                                        </Select>
                                                    </FormControl>
                                                </div>
                                                <div className={classNames({
                                                    'col-span-12': true,
                                                    'sm:col-span-8': isEnterprise,
                                                })}>
                                                    <FormControl variant="outlined">
                                                        <InputLabel id="filter-client" shrink>
                                                            <Trans i18nKey="common.issue">Issue</Trans>
                                                        </InputLabel>
                                                        <Select
                                                            labelId="filter-client"
                                                            label={
                                                                <Trans i18nKey="common.issue">
                                                                    Issue
                                                                </Trans>
                                                            }
                                                            value={issue.issue_id}
                                                            onChange={(e) =>
                                                                setData('devices', data.devices.map((item, i) => {
                                                                            if (i === index) {
                                                                                item.issues = item.issues.map((issueItem, i) => {
                                                                                        if (i === issueIndex) {
                                                                                            issueItem.issue_id = e.target.value;
                                                                                        }
                                                                                        return issueItem;
                                                                                    }
                                                                                )
                                                                            }
                                                                            return item;
                                                                        }
                                                                    ),
                                                                )}
                                                            notched
                                                            name={'issue'}
                                                        >
                                                            {device.entry.problems
                                                                .map((problem) => {
                                                                    return (
                                                                        <MenuItem
                                                                            key={problem.id}
                                                                            value={problem.id}
                                                                        >
                                                                            {problem.name.charAt(0).toUpperCase() + problem.name.slice(1)}
                                                                        </MenuItem>
                                                                    );
                                                                })}
                                                        </Select>
                                                    </FormControl>
                                                </div>
                                                {
                                                    isEnterprise && (
                                                        <div className={'col-span-12 sm:col-span-4'}>
                                                            <TextField
                                                                id="filled-number"
                                                                label="Amount"
                                                                type="number"
                                                                InputLabelProps={{
                                                                    shrink: true,
                                                                }}
                                                                inputProps={{
                                                                    inputMode: 'numeric',
                                                                    pattern: '[0-9]*',
                                                                    min: 1,
                                                                }}
                                                                variant="outlined"
                                                                value={issue.amount}
                                                                onChange={(e) =>
                                                                    setData('devices', data.devices.map((item, i) => {
                                                                                if (i === index) {
                                                                                    item.issues = item.issues.map((issueItem, i) => {
                                                                                            if (i === issueIndex) {
                                                                                                issueItem.amount = e.target.value;
                                                                                            }
                                                                                            return issueItem;
                                                                                        }
                                                                                    )
                                                                                }
                                                                                return item;
                                                                            }
                                                                        ),
                                                                    )}
                                                                InputLabelProps={{
                                                                    shrink: true,
                                                                }}
                                                            />
                                                        </div>
                                                    )}
                                                {
                                                    isEnterprise && (
                                                        <div className={'col-span-12 flex justify-end'}>
                                                            <p
                                                                onClick={() => {
                                                                    setData('devices', data.devices.map((item, i) => {
                                                                                if (i === index) {
                                                                                    item.issues = item.issues.filter((issueItem, i) => i !== issueIndex);
                                                                                }
                                                                                return item;
                                                                            }
                                                                        ),
                                                                    );
                                                                }}
                                                                className={'text-red-500 cursor-pointer m-0'}
                                                            >
                                                                <Trans i18nKey="emissions.deleteIssue">
                                                                    Delete issue
                                                                </Trans>
                                                                <svg width="17" height="16" viewBox="0 0 17 16" fill="none"
                                                                     xmlns="http://www.w3.org/2000/svg">
                                                                    <rect width="16" height="16" transform="translate(0.5)"
                                                                          fill="white"/>
                                                                    <path fillRule="evenodd" clipRule="evenodd"
                                                                          d="M6.76704 2.60021C6.90248 2.46476 7.08618 2.38867 7.27772 2.38867H9.72217C9.91371 2.38867 10.0974 2.46476 10.2329 2.60021C10.3683 2.73565 10.4444 2.91935 10.4444 3.11089V3.83313H6.5555V3.11089C6.5555 2.91935 6.63159 2.73565 6.76704 2.60021ZM5.5555 3.83313V3.11089C5.5555 2.65413 5.73695 2.21608 6.05993 1.8931C6.38291 1.57012 6.82096 1.38867 7.27772 1.38867H9.72217C10.1789 1.38867 10.617 1.57012 10.94 1.8931C11.2629 2.21608 11.4444 2.65413 11.4444 3.11089V3.83313H12.774L12.7777 3.83312L12.7814 3.83313H14C14.2761 3.83313 14.5 4.05699 14.5 4.33313C14.5 4.60927 14.2761 4.83313 14 4.83313H13.2777V12.8887C13.2777 13.3454 13.0963 13.7835 12.7733 14.1065C12.4503 14.4294 12.0123 14.6109 11.5555 14.6109H5.44439C4.98763 14.6109 4.54957 14.4294 4.2266 14.1065C3.90362 13.7835 3.72217 13.3454 3.72217 12.8887V4.83313H3C2.72386 4.83313 2.5 4.60927 2.5 4.33313C2.5 4.05699 2.72386 3.83313 3 3.83313H4.21844L4.22217 3.83312L4.22589 3.83313H5.5555ZM4.72217 4.83313V12.8887C4.72217 13.0802 4.79826 13.2639 4.9337 13.3994C5.06914 13.5348 5.25285 13.6109 5.44439 13.6109H11.5555C11.747 13.6109 11.9307 13.5348 12.0662 13.3994C12.2016 13.2639 12.2777 13.0802 12.2777 12.8887V4.83313H4.72217ZM7.27783 6.88867C7.55397 6.88867 7.77783 7.11253 7.77783 7.38867V11.0553C7.77783 11.3315 7.55397 11.5553 7.27783 11.5553C7.00169 11.5553 6.77783 11.3315 6.77783 11.0553V7.38867C6.77783 7.11253 7.00169 6.88867 7.27783 6.88867ZM10.2222 7.38867C10.2222 7.11253 9.99831 6.88867 9.72217 6.88867C9.44603 6.88867 9.22217 7.11253 9.22217 7.38867V11.0553C9.22217 11.3315 9.44603 11.5553 9.72217 11.5553C9.99831 11.5553 10.2222 11.3315 10.2222 11.0553V7.38867Z"
                                                                          fill="#DD3535"/>
                                                                </svg>
                                                            </p>
                                                        </div>
                                                    )
                                                }
                                            </div>
                                        ))
                                    }
                                    {
                                        isEnterprise && (<div className={'mt-6'}>
                                                <Button
                                                    endIcon={<AddCircleOutline/>}
                                                    onClick={() => {
                                                        setData('devices', data.devices.map((item, i) => {
                                                                    if (i === index) {
                                                                        item.issues = [
                                                                            ...item.issues,
                                                                            {
                                                                                issue_id: '',
                                                                                amount: 1,
                                                                            }
                                                                        ]
                                                                    }
                                                                    return item;
                                                                }
                                                            ),
                                                        )
                                                    }}
                                                >
                                                    Add issue
                                                </Button>
                                            </div>
                                        )
                                    }
                                </div>
                            ))
                        }
                    </div>
                </Container>
            </div>
            {
                data.devices.length > 0 && (
                    <div
                        className={'sticky w-full p-3 flex z-10 justify-center bg-white shadow-[0_1px_10px_1px_rgba(0,0,0,0.3)] bottom-0 z-10'}>
                        <Container maxWidth={'md'}>
                            <div className={'flex justify-between items-center'}>
                                <h2>{data.devices.length} device added</h2>
                                <Button
                                    variant="contained"
                                    color={'secondary'}
                                    sx={{
                                        background: errorFree && !processing ? 'var(--b-2-x-gradient, linear-gradient(90deg, #FF4F50 0%, #CE0A7F 100%))' : undefined,
                                        textTransform: 'none',
                                        fontWeight: 'bold',
                                    }}
                                    onClick={handleClickOpen}
                                    disabled={!errorFree || processing}
                                    id={'calculate'}
                                >
                                    <Trans i18nKey="emissions.calculateCO2Footprint">
                                        Calculate CO2e Footprint
                                    </Trans>
                                </Button>
                            </div>
                        </Container>
                    </div>
                )
            }
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>
                    <Trans i18nKey="emissions.emailCopyResults">
                        We would like to send you a copy of the results.
                    </Trans>
                </DialogTitle>
                <DialogContent>
                    <p>
                        <Trans i18nKey="emissions.emailHeading">
                            Please provide us your email address
                        </Trans>
                    </p>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="name"
                        name="email"
                        label="Email Address"
                        type="email"
                        fullWidth
                        variant="standard"
                        value={data.email}
                        onChange={(e) =>
                            setData('email', e.target.value)
                        }
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' && /^[\w-\.]+@([\w-]+\.)+[\w-]{2,}$/.exec(data.email) !== null) {
                                post(route('emissions.store'));
                            }
                        }}
                        disabled={processing}
                    />
                    {/*<div className={'mt-3'}>*/}
                    {/*    <FormControlLabel*/}
                    {/*        id={'marketingConsentLabel'}*/}
                    {/*        control={*/}
                    {/*            <Checkbox*/}
                    {/*                checked={data.marketingConsent}*/}
                    {/*                onChange={(e) =>*/}
                    {/*                    setData('marketingConsent', e.target.checked)*/}
                    {/*                }*/}
                    {/*                name={'marketingConsent'}*/}
                    {/*                color="primary"*/}
                    {/*                disabled={processing}*/}
                    {/*            />*/}
                    {/*        }*/}
                    {/*        label={*/}
                    {/*            <Trans i18nKey="emissions.marketingConsent">*/}
                    {/*                With your consent B2X may send you news about future products and services.*/}
                    {/*            </Trans>*/}
                    {/*        }*/}
                    {/*    />*/}
                    {/*</div>*/}
                    <DialogContentText sx={{marginTop: 3}}>
                        <Trans i18nKey="emissions.legalInfo">
                            B2X needs your email address to provide you with a copy of the results. For more information
                            about our privacy practices and commitment to protecting your privacy, please review our <a
                            href={'https://b2x.com/privacy-policy/'} target={'_blank'}>Privacy Policy</a>.
                        </Trans>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button
                        color={'secondary'}
                        variant={'contained'}
                        onClick={() => {
                            post(route('emissions.store'));
                        }}
                        disabled={processing || /^[\w-\.]+@([\w-]+\.)+[\w-]{2,}$/.exec(data.email) === null}
                        id={'showResults'}
                    >
                        <Trans i18nKey="emissions.showResults">
                            Show results
                        </Trans>
                    </Button>
                </DialogActions>
            </Dialog>
            <div className={'hidden lg:block lg:absolute left-0 top-[8rem] z-0 max-h-full'}>
                <svg xmlns="http://www.w3.org/2000/svg" className={'h-[calc(100vh-8rem)] max-h-[42rem] w-auto'}
                     width="475"
                     preserveAspectRatio="xMidYMid meet" height="1018" viewBox="0 0 475 1018" fill="none">
                    <path opacity="0.7"
                          d="M375.929 584.61C417.753 358.256 268.162 140.855 41.8088 99.0304C-184.545 57.2061 -401.946 206.797 -443.77 433.15C-485.595 659.504 -336.004 876.905 -109.65 918.73C116.703 960.554 334.104 810.963 375.929 584.61Z"
                          stroke="#EBEDEF" strokeWidth="184"/>
                </svg>
            </div>
        </div>
    )
}


Emissions.layout = page => <Layout children={page}/>;
